import { useState } from 'react';
import { Button, Row, Col } from 'antd';
import { FiArrowLeftCircle, FiArrowRight, FiArrowRightCircle, FiBarChart, FiCommand, FiGlobe, FiMapPin, FiMousePointer, FiPenTool, FiSearch } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';


export const Features = () => {

        const navigate = useNavigate();

        const reviews = [
                {
                        name:   "Michael Broadbridge",
                        company: "Fun Cases",
                        image:  "reviews/fun-cases.jpeg",
                        review: "Service has been outstanding in producing and maintaining our social media ads. They didn’t just hit our target ROAS, they smashed it by a mile."
                },
                {
                        name:   "Chris Jakeways",
                        company: "Vanaways",
                        image:  "reviews/vanaways.jpeg",
                        review: "These guys know their stuff! Finding Bigg has made a massive difference to our business and helped to make us one of the country's largest suppliers of Vans."
                },
                {
                        name:   "Kirsty McNeil",
                        company: "Western Global",
                        image:  "reviews/western-global.jpeg",
                        review: "We have worked with these guys since 2019, at first with the UK side of our business, however they now partner with us for our US growth market."
                },
                {
                        name:   "Maxim Lyashco",
                        company: "ICS",
                        image:  "reviews/ics.jpeg",
                        review: "I'm more than happy not only with the quality of their work but also with their customer support. The communication from the team has been excellent."
                },
                
        ]
        const [ reviewNumber, setReviewNumber ] = useState(0)

        const changeReview = (i) => {

                let newReviewNumber = reviewNumber + i

                if (newReviewNumber > reviews.length - 1) {
                        newReviewNumber = 0
                } else if (newReviewNumber < 0) {
                        newReviewNumber = reviews.length -1
                }

                setReviewNumber(newReviewNumber)

                
        }

        const reviewItem = () => {

                const r = reviews[reviewNumber]

                return (
                        <div className="section grey" style={{paddingTop: 100, paddingBottom: 100}}>
                                <div className="container thin">
                                        <div className="review">
                                                <h2 style={{textAlign: 'center'}}>What our clients say</h2>
                                                <Row gutter={15} display="flex" justify={"center"}>
                                                        <Col sm={8}>
                                                                <div style={{textAlign: 'center'}}>
                                                                        <div className="review-image">
                                                                                <img src={`/images/${r.image}`} alt="review"/>
                                                                        </div>
                                                                        <div className="reviewArrow" onClick={() => changeReview(-1)}>
                                                                                <FiArrowLeftCircle size={50} color={"#fff"} fill={"#000"} />
                                                                        </div>
                                                                        <div className="reviewArrow"onClick={() => changeReview(1)}>
                                                                                <FiArrowRightCircle size={50} color={"#fff"} fill={"#000"} />
                                                                        </div>
                                                                        
                                                                </div>
                                                        </Col>
                                                        <Col sm={15} offset={1}>
                                                                
                                                                
                                                                
                                                                <div className="review-name">
                                                                        {r.name}
                                                                </div>
                                                                <div className="review-company">
                                                                        {r.company}
                                                                </div>
                                                                <p className="reviewText">
                                                                        “{r.review}”
                                                                </p>
                                                                <div className="quoteMark">
                                                                        "
                                                                </div>
                                                        
                                                        </Col>
                                                        <Col sm={4}>
                                                                
                                                        </Col>
                                                </Row>
                                        </div>
                                </div>
                        </div>
                )
        }

        const banner = () => {

                return (
                        <div id="builder-banner">
                                <div className="container">
                                        {/* <Row gutter={15} align="middle">
                                                <Col sm={24}>
                                                        <div className="heroText">
                                                                <h1>Package Builder</h1>
                                                                <h4>Answer the questions below to build your custom SmartPromote package</h4>
                                                        </div>
                                                </Col>
                                               
                                        </Row> */}
                                        
                                        
                                        
                                </div>
                        </div>
                )
        }
        
        const headline = () => {

                return (
                        <div style={{paddingBottom: 50}}>
                                <div className="container">
                                        <Row gutter={15} align="middle">
                                                <Col sm={24}>
                                                        <div className="heroText" style={{textAlign: 'center'}}>
                                                                <h1>All aspects of marketing in one complete solution</h1>
                                                                <h4 style={{maxWidth: 800, lineHeight: '26px', margin: '0 auto'}}>
                                                                        The perfect blend of marketing services designed specifically for your business, wrapped up into one 
                                                                        affordable package and optimised each
                                                                        month to produce greater results.
                                                                </h4>
                                                        </div>
                                                       
                                                </Col>
                                                <Col sm={24}>
                                                        <div className="serviceBoxes">
                                                                <Row gutter={15} align="center">
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiCommand />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Social<br/>marketing
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiSearch />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Search<br/>Ads
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiMousePointer />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Social<br/>Ads
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiGlobe />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Website<br/>Management
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiMapPin />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Graphic<br/>Design
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiPenTool />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Content<br/>Writing
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                                <div className="serviceItem">
                                                                                        <div className="serviceIcon">
                                                                                                <FiBarChart />
                                                                                        </div>
                                                                                        <div className="serviceName">
                                                                                                Search<br/>Optimisation
                                                                                        </div>
                                                                                </div>
                                                                        </Col>
                                                                </Row>
                                                        </div>

                                                        <div style={{textAlign: 'center', marginTop: 50}}>
                                                                <Button onClick={() => navigate('/builder')} style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                }} type="primary">Build your package <FiArrowRight style={{marginLeft: 5}}/> </Button>
                                                                <Button type="blackoutline">Get in touch</Button>
                                                        </div>
                                                </Col>
                                        </Row>
                                        
                                        
                                        
                                </div>
                        </div>
                )
        }

        const socialMarketing = () => {

                return (
                        <>
                        <div className="section">
                                <div className="container">
                                        <div >
                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        <Col sm={10}>
                                                                <h4 className="featureHeader">SOCIAL MARKETING</h4>
                                                                <h2>
                                                                        Connecting and engaging with your perfect customer
                                                                </h2>
                                                                <p>
                                                                        Based on your target audience's location, age range, interests and more, your package 
                                                                        will include the social networks with the best fit to connect, engage and interact with 
                                                                        your perfect customer.
                                                                </p>
                                                        </Col>
                                                        <Col sm={10}  offset={2}>
                                                                <div className="featureImage">
                                                                        <img src="https://b2597446.smushcdn.com/2597446/wp-content/uploads/2022/05/bigg-social-management-lottery-usa-1.png?lossy=1&strip=1&webp=1" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>

                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        
                                                        <Col sm={10} >
                                                                <div className="featureImage">
                                                                        <img src="https://b2597446.smushcdn.com/2597446/wp-content/uploads/2022/05/bigg-paid-advertising-stalbridge-linen-1.png?lossy=1&strip=1&webp=1" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        <Col sm={10} offset={2}>
                                                                <h4 className="featureHeader">SEARCH ADS</h4>
                                                                <h2>
                                                                        Carefully craft search Ads designed turn keywords into sales
                                                                </h2>
                                                                <p>
                                                                        Using Google and Microsoft Ad networks, we'll research, create, manage and optimise
                                                                        your advertising on search to deliver quality visitors and maximum conversions.
                                                                </p>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>

                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        <Col sm={10}>
                                                                <h4 className="featureHeader">SOCIAL ADS</h4>
                                                                <h2>
                                                                        Highly targeted Ads that disrupt attention at the right time
                                                                </h2>
                                                                <p>
                                                                        Based on your target audience's location, age range, interests and more, your package 
                                                                        will include the social networks with the best fit to connect, engage and interact with 
                                                                        your perfect customer.
                                                                </p>
                                                        </Col>
                                                        <Col sm={10}  offset={2}>
                                                                <div className="featureImage">
                                                                        <img src="https://b2597446.smushcdn.com/2597446/wp-content/uploads/2022/05/bigg-social-management-sci-1.png?lossy=1&strip=1&webp=1" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>

                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        
                                                        <Col sm={10} >
                                                                <div className="featureImage">
                                                                        <img src="https://valleywebdesigns.uk/wp-content/uploads/2020/12/website-management-services.png" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        <Col sm={10} offset={2}>
                                                                <h4 className="featureHeader">WEBSITE MANAGEMENT</h4>
                                                                <h2>
                                                                        Keeping your website working for you when it matters
                                                                </h2>
                                                                <p>
                                                                        Every package includes keeping your site up to date with the latest standards, ensuring
                                                                        you're error free and providing the best experience for your visitors.
                                                                </p>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>

                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        <Col sm={10}>
                                                                <h4 className="featureHeader">GRAPHIC DESIGN</h4>
                                                                <h2>
                                                                        Bespoke design services supporting your campaign
                                                                </h2>
                                                                <p>
                                                                        Almost every aspect of marketing includes a visual element and so our campaign managers have access to
                                                                        a team of designers ready to enhance your presence online.
                                                                </p>
                                                        </Col>
                                                        <Col sm={10}  offset={2}>
                                                                <div className="featureImage">
                                                                        <img src="https://b2597446.smushcdn.com/2597446/wp-content/uploads/2022/05/bigg-branding-carzuno.png?lossy=1&strip=1&webp=1" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>

                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        
                                                        <Col sm={10} >
                                                                <div className="featureImage">
                                                                        <img src="https://b2597446.smushcdn.com/2597446/wp-content/uploads/2022/06/bigg-content-writing-crypto-prophecies.png?lossy=1&strip=1&webp=1" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        <Col sm={10} offset={2}>
                                                                <h4 className="featureHeader">CONTENT WRITING</h4>
                                                                <h2>
                                                                        Words that inspire audiences to take action
                                                                </h2>
                                                                <p>
                                                                        From adverts and social content to website pages and blog posts, our team of writers will research, write
                                                                        and distribute your content in a way that generates an action. 

                                                                </p>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>

                                                <div className="feature">
                                                <Row gutter={15} align="middle">
                                                        <Col sm={10}>
                                                                <h4 className="featureHeader">SEARCH OPTIMISATION</h4>
                                                                <h2>
                                                                        Ranking where is actually makes a difference
                                                                </h2>
                                                                <p>
                                                                        We carefully select search phrases we know will deliver the high quality visitors needed to turn 
                                                                        clicks into actions and help to steadily grow your business.
                                                                </p>
                                                        </Col>
                                                        <Col sm={10}  offset={2}>
                                                                <div className="featureImage">
                                                                        <img src="https://b2597446.smushcdn.com/2597446/wp-content/uploads/2022/05/bigg-search-optimisation-vanango.png?lossy=1&strip=1&webp=1" alt="home-team"/>
                                                                </div>
                                                        </Col>
                                                        
                                                </Row>
                                                </div>
                                        </div>
                                </div>
                        </div>
                        
                        </>
                )
        }

        const readytogrow = () => {

                return (
                        <>
                        <div className="section">
                                <div className="container">
                                        <div style={{paddingTop: 0, paddingBottom: 100}}>
                                                <h2 style={{textAlign: 'center'}}>
                                                        Ready to start growing<br/>your business?
                                                </h2>
                                                <p style={{margin: '0 auto', maxWidth: 800, textAlign: 'center'}}>
                                                        We can't wait to start working with you, click below to start building your package by telling
                                                        us a little about who you're targeting, where they are and how much you want to invest.
                                                </p>
                                                <div style={{textAlign: 'center', marginTop: 50}}>
                                                <Button onClick={() => navigate('/builder')} style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                }} type="primary">Build your package <FiArrowRight style={{marginLeft: 5}}/> </Button>
                                                        <Button type="blackoutline">Get in touch</Button>
                                                </div>
                                        </div>
                                </div>
                        </div>
                        </>
                )
        }

        return (
                <div className="page">
                        { banner() }
                        { headline() }
                        { socialMarketing() }
                        
                        { reviewItem() }
                        { readytogrow() }
                </div>
        )
}